<div class="flex flex-column gap-5">
  <!-- Status paketa summary card -->
  <div class="status-card">
    <div class="text-md-semibold text-gray-900">Status paketa</div>

    <div class="mt-4 flex flex-column md:flex-row gap-3">
      <div class="stat-tile flex align-items-center gap-3 flex-1">
        <div class="stat-icon">
          <app-check-circle stroke="#414651" width="16" height="16"></app-check-circle>
        </div>
        <div class="flex flex-column">
          <span class="text-sm-medium text-gray-600">Preostalo</span>
          <div class="mt-1 text-gray-900">
            <span class="display-xs-semibold">{{ stats()?.availableHours ?? 0 }}</span>
            <span class="display-xs-semibold text-gray-400">&nbsp;h</span>
          </div>
        </div>
      </div>

      <div class="stat-tile flex align-items-center gap-3 flex-1">
        <div class="stat-icon">
          <app-hourglas-03 stroke="#414651" width="16" height="16"></app-hourglas-03>
        </div>
        <div class="flex flex-column">
          <span class="text-sm-medium text-gray-600">Iskorišćeno</span>
          <div class="mt-1 text-gray-900">
            <span class="display-xs-semibold">{{ stats()?.usedHours ?? 0 }}</span>
            <span class="display-xs-semibold text-gray-400">&nbsp;h</span>
          </div>
        </div>
      </div>

      <div class="stat-tile flex align-items-center gap-3 flex-1">
        <div class="stat-icon">
          <app-cube-01 stroke="#414651" width="16" height="16"></app-cube-01>
        </div>
        <div class="flex flex-column">
          <span class="text-sm-medium text-gray-600">Ukupno</span>
          <div class="mt-1 text-gray-900">
            <span class="display-xs-semibold">{{ stats()?.totalHours ?? 0 }}</span>
            <span class="display-xs-semibold text-gray-400">&nbsp;h</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4 flex align-items-center justify-content-between">
      <span class="text-sm-medium text-gray-600">Iskorišćenost</span>
      <span class="text-sm-semibold text-gray-900">{{ formatNumber(stats()?.usedPercentage) }}%</span>
    </div>
    <div class="usage-bar-track mt-2">
      <div
        class="usage-bar-fill"
        [style.width.%]="stats()?.usedPercentage ?? 0"
      ></div>
    </div>
  </div>

  <!-- Sub-tabs -->
  <div>
    <p-tabs class="transparent compact-tabs" [value]="activeTab()" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab [value]="0">
          <div class="flex align-items-center gap-2">
            <app-check-circle
              [stroke]="activeTab() === 0 ? '#181D27' : '#7E838F'"
              width="14px"
              height="14px"
            ></app-check-circle>
            <span class="text-sm-semibold">Aktivni</span>
          </div>
        </p-tab>
        <p-tab [value]="1">
          <div class="flex align-items-center gap-2">
            <app-clock-rewind
              [stroke]="activeTab() === 1 ? '#181D27' : '#7E838F'"
              width="14px"
              height="14px"
            ></app-clock-rewind>
            <span class="text-sm-semibold">Istorija</span>
          </div>
        </p-tab>
        <p-tab [value]="2">
          <div class="flex align-items-center gap-2">
            <app-loading-01
              [stroke]="activeTab() === 2 ? '#181D27' : '#7E838F'"
              width="14px"
              height="14px"
            ></app-loading-01>
            <span class="text-sm-semibold">U obradi</span>
          </div>
        </p-tab>
      </p-tablist>
    </p-tabs>

    <!-- Table -->
    <p-table
      class="mt-3"
      [class.is-empty]="!isLoading && packages.length === 0"
      [value]="packages"
      [lazy]="true"
      [paginator]="(paginatedData.totalCount ?? 0) > 0"
      [first]="first"
      [rows]="paginatedData.pageSize!"
      [totalRecords]="paginatedData.totalCount!"
      [loading]="isLoading"
      [tableStyleClass]="packages.length === 0 ? 'hide-header' : ''"
      (onLazyLoad)="loadLazy($event)"
      [showFirstLastIcon]="false"
    >
      <!-- HEADER -->
      <ng-template #header>
        <tr>
          <th>
            <div class="text-xs-semibold text-gray-400 pt-2-5">PAKET</div>
          </th>
          <th>
            <div class="text-xs-semibold text-gray-400 header-cell">STATUS</div>
          </th>

          @switch (activeTab()) {
            @case (0) {
              <th>
                <div class="text-xs-semibold text-gray-400 header-cell">PREOSTALO SATI</div>
              </th>
              <th>
                <div class="text-xs-semibold text-gray-400 header-cell">DATUM AKTIVACIJE</div>
              </th>
              <th>
                <div class="text-xs-semibold text-gray-400 header-cell">DATUM ISTEKA</div>
              </th>
            }
            @case (1) {
              <th>
                <div class="text-xs-semibold text-gray-400 header-cell">PREOSTALO SATI</div>
              </th>
              <th>
                <div class="text-xs-semibold text-gray-400 header-cell">DATUM AKTIVACIJE</div>
              </th>
              <th>
                <div class="text-xs-semibold text-gray-400 header-cell">DATUM ISTEKA</div>
              </th>
            }
            @case (2) {
              <th>
                <div class="text-xs-semibold text-gray-400 header-cell">DATUM ZAHTEVA</div>
              </th>
              <th>
                <div class="text-xs-semibold text-gray-400 header-cell">SLEDEĆI KORAK</div>
              </th>
            }
          }
        </tr>
      </ng-template>

      <!-- BODY -->
      <ng-template #body let-pkg>
        <tr class="cursor-pointer" (click)="routeToPackageDetails(pkg.id)">
          <!-- Package name -->
          <td>
            <div class="flex align-items-center gap-3">
              <div class="package-icon">
                <app-cube-01 stroke="#ADB0B8" width="16" height="16"></app-cube-01>
              </div>
              <span class="text-sm-medium text-gray-900">{{ pkg.name }}</span>
            </div>
          </td>

          <!-- Status chip -->
          <td>
            @if (activeTab() === 1) {
              <p-chip
                [label]="getIstorijaChipLabel(pkg)"
                [class]="getIstorijaChipClass(pkg)"
              ></p-chip>
            } @else {
              <p-chip
                [label]="pkg.status?.description ?? ''"
                [class]="getStatusChipClass(pkg.status)"
              ></p-chip>
            }
          </td>

          @switch (activeTab()) {
            @case (0) {
              <td>
                <div class="flex align-items-center gap-3">
                  <div class="progress-bar-track">
                    <div
                      class="progress-bar-fill"
                      [class.progress-bar-fill--red]="isBarRed(pkg)"
                      [style.width.%]="getBarPercent(pkg)"
                    ></div>
                  </div>
                  <span class="hours-text">
                    <span class="text-sm-semibold text-gray-900">{{ pkg.remainingHours ?? 0 }}</span>
                    <span class="text-sm-medium text-gray-500"> / {{ pkg.totalHours ?? 0 }}</span>
                  </span>
                </div>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validFrom ? getDateFormatedSr(pkg.validFrom) : '-' }}
                </span>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validTo ? getDateFormatedSr(pkg.validTo) : '-' }}
                </span>
              </td>
            }
            @case (1) {
              <td>
                <span class="hours-text">
                  <span class="text-sm-semibold text-gray-900">{{ pkg.remainingHours ?? 0 }}</span>
                  <span class="text-sm-medium text-gray-500"> / {{ pkg.totalHours ?? 0 }}</span>
                </span>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validFrom ? getDateFormatedSr(pkg.validFrom) : '-' }}
                </span>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validTo ? getDateFormatedSr(pkg.validTo) : '-' }}
                </span>
              </td>
            }
            @case (2) {
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{ pkg.validFrom ? getDateFormatedSrWithTime(pkg.validFrom) : '-' }}
                </span>
              </td>
              <td>
                <span class="text-sm-medium text-gray-900">
                  {{
                    pkg.status?.value === 0
                      ? 'Faktura u pripremi'
                      : pkg.status?.value === 1
                        ? 'Čeka se uplata'
                        : '-'
                  }}
                </span>
              </td>
            }
          }
        </tr>
      </ng-template>

      <!-- EMPTY -->
      <ng-template #emptymessage>
        <tr>
          <td [attr.colspan]="activeTab() === 2 ? 4 : 5">
            <div class="flex justify-content-center align-items-center text-gray-900 text-lg-semibold py-5">
              Nema paketa
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- LOADING -->
      <ng-template #loadingbody>
        @for (row of [1, 2, 3, 4, 5]; track row) {
          <tr>
            <td>
              <div class="flex align-items-center gap-2">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
                <p-skeleton width="5rem"></p-skeleton>
              </div>
            </td>
            <td><p-skeleton width="5rem"></p-skeleton></td>
            <td><p-skeleton width="7rem"></p-skeleton></td>
            <td><p-skeleton width="6rem"></p-skeleton></td>
            @if (activeTab() !== 2) {
              <td><p-skeleton width="6rem"></p-skeleton></td>
            }
          </tr>
        }
      </ng-template>

      <!-- PAGINATOR LEFT -->
      <ng-template #paginatorleft>
        <app-button
          [btnSize]="ButtonSize.SM"
          [btnSeverity]="ButtonSeverity.SECONDARY"
          (btnClicked)="prev()"
          [isBtnDisabled]="!paginatedData.hasPreviousPage"
        >
          <app-arrow direction="left" stroke="#3D3B3A"></app-arrow>
          <div class="paginator-btn-label text-sm-semibold text-gray-700">Nazad</div>
        </app-button>
      </ng-template>

      <!-- PAGINATOR RIGHT -->
      <ng-template #paginatorright>
        <app-button
          [btnSize]="ButtonSize.SM"
          [btnSeverity]="ButtonSeverity.SECONDARY"
          (btnClicked)="next()"
          [isBtnDisabled]="!paginatedData.hasNextPage"
        >
          <div class="paginator-btn-label text-sm-semibold text-gray-700">Dalje</div>
          <app-arrow direction="right" stroke="#3D3B3A"></app-arrow>
        </app-button>
      </ng-template>
    </p-table>
  </div>
</div>
